import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  const load = useCallback(async () => {
    if (!localStorage.getItem("tqi_token")) return setUser(false);
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(false);
    }
  }, []);

  useEffect(() => {
    load();
    const onLogout = () => setUser(false);
    window.addEventListener("tqi:logout", onLogout);
    return () => window.removeEventListener("tqi:logout", onLogout);
  }, [load]);

  const login = (token, u) => {
    localStorage.setItem("tqi_token", token);
    setUser(u);
  };
  const logout = () => {
    localStorage.removeItem("tqi_token");
    setUser(false);
  };

  return <AuthContext.Provider value={{ user, login, logout, isAdmin: user?.role === "admin", reload: load }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
